import ResearchGroupIntro from '../Components/ResearchGroupIntro';

const IndustryIntro = () => {
    return <ResearchGroupIntro route="/industry" />;
}
export default IndustryIntro;
